import React from "react";
import Layout from "../../../components/Layout/Layout.component";
import ConfigurationMenu from "./pages/Configuration";
import QATicketPage from "./pages/QATicket/QATicket.page";
import redirect from "../../modules/redirect";
import NestedRoutes from "../../components/NestedRoutes";
import { ROLES } from "../../../constants/rolesConstants";
import {
  ProductsRouter,
  UsersRouter,
  MyAccountRouter,
  ReportsRouter,
} from "./routers";
import InterviewDatesPage from "./pages/InterviewDates";
import InterviewConfigurationPage from "./pages/InterviewConfiguration";
import TasksPage from "./pages/Task";
import TasksRedirect from "./pages/Task/TasksRedirect";
import APIAccessLog from "./pages/APIAccessLog";
import DS82StuckBot from "./pages/DS82StuckBot";
import PortraitReview from "./pages/PortraitReview";
import WhatsAppPage from "./pages/WhatsApp";
import Announcements from "../../../pages/Announcements/Announcements.page";

const routes = [
  {
    path: "/support/:configType",
    component: ConfigurationMenu,
  },
  {
    path: "/tasks",
    component: TasksRedirect,
  },
  {
    path: "/tasks/pko",
    component: TasksPage,
    componentProps: { processingState: "PR" },
    authorizedRoles: [ROLES.ADMIN, ROLES.PKO_OFFICE],
  },
  {
    path: "/tasks/pko-us",
    component: TasksPage,
    componentProps: { processingState: "PA" },
    authorizedRoles: [ROLES.ADMIN, ROLES.PKO_OFFICE_US],
  },
  {
    path: "/api-access-log",
    component: APIAccessLog,
    authorizedRoles: [ROLES.ADMIN],
  },
  {
    path: "/ds82-stuck-bot",
    component: DS82StuckBot,
    authorizedRoles: [ROLES.ADMIN],
  },
  {
    path: "/portrait-review",
    component: PortraitReview,
    authorizedRoles: [
      ROLES.ADMIN,
      ROLES.L2_AGENT,
      ROLES.L1_MANAGER,
      ROLES.L2_MANAGER,
      ROLES.QA_MANAGER,
      ROLES.BT_MANAGER,
    ],
  },
  {
    path: "/whatsapp/:phone?",
    component: WhatsAppPage,
    authorizedRoles: [
      ROLES.ADMIN,
      ROLES.L1_AGENT,
      ROLES.L2_AGENT,
      ROLES.L1_MANAGER,
      ROLES.L2_MANAGER,
      ROLES.QA_MANAGER,
      ROLES.BT_MANAGER,
    ],
  },
  {
    path: "/reports",
    component: ReportsRouter,
    authorizedRoles: [ROLES.ADMIN],
    exact: false,
  },
  {
    path: "/users",
    authorizedRoles: [
      ROLES.ADMIN,
      ROLES.L1_MANAGER,
      ROLES.L2_MANAGER,
      ROLES.QA_MANAGER,
      ROLES.BT_MANAGER,
    ],
    exact: false,
    component: UsersRouter,
  },
  {
    path: "/my-account",
    exact: false,
    component: MyAccountRouter,
  },
  {
    path: "/interview-dates",
    component: InterviewDatesPage,
  },
  {
    path: "/interview-dates/configuration",
    component: InterviewConfigurationPage,
  },
  {
    path: "/evaluation-tickets/:id",
    component: QATicketPage,
  },
  {
    path: "/announcements",
    component: Announcements,
    authorizedRoles: [ROLES.ADMIN],
  },
  {
    path: "",
    component: redirect("/esta"),
  },
  {
    component: ProductsRouter,
    exact: false,
  },
];

const DashboardRouter = () => {
  return (
    <Layout zendeskView={false}>
      <NestedRoutes routes={routes} />
    </Layout>
  );
};

export default DashboardRouter;
